/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AppsInputs */

const en_nav_apps = /** @type {(inputs: Nav_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps`)
};

const es_nav_apps = /** @type {(inputs: Nav_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicaciones`)
};

/**
* | output |
* | --- |
* | "Apps" |
*
* @param {Nav_AppsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_apps = /** @type {((inputs?: Nav_AppsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AppsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_apps(inputs)
	return en_nav_apps(inputs)
});